import config from '../../constants/config';
import { getCleanUsername } from '../helpers/utils';

export default {
  and: 'and',
  SignUp: 'Sign Up',
  LogIn: 'Log In',
  LOGIN: 'LOG IN',
  Close: 'Close',
  Ok: 'OK',
  Back: 'Back',
  He: 'He',
  She: 'She',
  Him: 'Him',
  Her: 'Her',
  Find: 'Find',
  Thanks: 'Thanks',
  SingUpLanding: 'Tap here to find',
  LogInLanding: 'Already a member? Log In here',
  TitleLanding: 'Tired of old dating sites?',
  SubTitleLanding:
    'So are we! Discover a new experience at ' +
    config.TITLE +
    ' with features like these:',
  logInWithApple: 'Log In with Apple',
  mailIsConfirmed:
    'Congratulations! Your account has been successfully activated. Thank you for verifying your email. You can now enjoy full access to our services.',
  SignUpWithEmail: 'Sign Up with Email',
  reactivateAccount: 'Reactivate Account',
  welcomeBack: 'Welcome back',
  prevYouDeactivYourAcc: 'Previously, you deactivated your account',
  doUwantToReacYourAcc: 'Do you want to reactivate your account',
  yesReactivateMyAcc: 'Yes, Reactivate My Account',
  noKeepDeactivated: 'No, Keep Deactivated',
  signUpWithApple: 'Sign Up with Apple',
  TermsOfService: 'Terms\u00A0of\u00A0Service',
  PrivacyPolicy: 'Privacy\u00A0Policy',
  JoinToday: 'Join Today',
  firstName: 'First Name',
  yourFirstName: 'Please Tell me your First Name',
  EmailAddress: 'Email Address',
  password: 'Password',
  EnterEmailAddress: 'Enter email address',
  EnterPassword: 'Enter password',
  PleaseEnterValidEmail: 'Please enter valid email address',
  PleaseEnterPassword: 'Please enter password',
  LandPageHeader: 'Ready for a new adventure?',
  LandPageSubHeader:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) +
    ' Dating connects ' +
    config.NICHE_SINGULAR +
    ' singles looking for a romance',
  LandPageLegal: 'By logging in, you accept our',
  LandPageAllDevices: 'Available on All Devices',
  ForgotYourPassword: 'Forgot your password?',
  or: 'or',
  Save: 'Save',
  views: 'Views',
  view: 'View',
  ViewedMyProfile: 'Viewed Profile',
  ViewProfile: 'View Profile',
  UnmatchDelete: 'Unmatch / Delete',
  UnmatchDeleteQuestionMark: 'Unmatch/Delete?',
  UnmatchDeleteText:
    'Are you sure you want to Unmatch/Delete? You will no longer have access to your chat history with ',
  YesUnmatchDelete: 'Yes, Unmatch/Delete',
  IViewed: 'I Viewed',
  ViewedMe: 'Viewed Me',
  LikesMe: 'Likes Me',
  Mutual: 'Mutual',
  MyLikes: 'My Likes',
  Chat: 'Chat',
  Flirts: 'Flirts',
  Send: 'Send',
  typing: 'typing',
  UpgradeToVIP: 'Upgrade To VIP',
  TypeAMessageHere: 'Type a message here',
  FeaturesChat: 'Chat',
  SendMessagesToWhoYouWant: 'Send messages to who you want',
  SeeWhoIsInterestedInYou: 'See who is interested in you',
  SeeWhoIsReallyInterestedInYou: 'See who is really interested in you',
  IncreaseYourChancesWithAFlirt: 'Increase your chances with a Flirt',
  GetDatesFast: 'Get dates fast by saying Yes or No',
  FeaturesIncluded: 'Features Included',
  Matches: 'Matches',
  Likes: 'Likes',
  QuickMatch: 'Quick Match',
  Search: 'Search',
  Favorite: 'Favorite',
  Favorites: 'Favorites',
  Browse: 'Browse',
  MyProfile: 'My Profile',
  Settings: 'Settings',
  // Logout
  LogoutH1: 'You Have Logged Out Successfully',
  LogoutP: 'You will be missed...',
  LogoutButton: 'Log In Again',
  // Unsubscribe
  tooManyEmails: 'Too many emails',
  enterYourEmailBelowToUnsub: 'Enter your email below to unsubscribe',
  unsubscribe: 'Unsubscribe',
  unsubscribeSuccess: 'Unsubscribe Successful',
  youWillNoLongerReceiveAnyEmailFromUs:
    'You will no longer receive any emails from us',
  unSubByAccident: 'Unsubscribed by accident',
  reSubHere: 'Re-subscribe Here',
  helpUsGetBetter: 'Help us get better',
  tellUsWhyYouUnSub: 'Tell us why you unsubscribed',
  resubscribeSuccessful: 'Resubscribe Successful',
  clickHere: 'Click here',
  toGoBackToTheSite: 'to go back to the site',
  pleaseSelectOneOfTheReasonsBelow: 'Please select one of the reasons below',
  notEnoughUsers: 'Not enough users',
  complicatedToUse: 'Complicated to use',
  notEnoughOptions: 'Not enough options',
  betterAlternatives: 'Better alternatives',
  badExperienceWithAnotherUser: 'Bad experience with another user',
  technicalIssues: 'Technical issues',
  thanksForYourFeedback: 'Thanks for your feedback',
  tapHere: 'Tap here',
  // Who's online
  WhosOnline: "Who's Online",
  Recent: 'Recent',
  ThisWeek: 'This Week',
  MembsWereOnlineRec: 'Members Were Online Recently',
  MembsWereOnlineWeek: 'Members Were Online This Week',
  MembsRecWillAppHere: 'Members recently online will appear here',
  MembsThisWeekWillAppHere: 'Members online this week will appear here',
  // Browse
  BrowseZero: 'There are',
  BrowseZero2: 'Members',
  BrowseMembersAppear: 'Members will appear here',
  // Favorites
  MyFavorites: 'My Favorites',
  FavoritedMe: 'Favorited Me',
  YourFavWillAppHere: 'Your favorites will appear here',
  MembHaveFavU: 'Members Have Favorited You',
  MembWhoFavU: 'Members who favorited you will appear here',
  NewPasswordSet: 'New password set. Now you can login.',
  // Password Recovery
  recoveryTittle: 'Password Recovery',
  recoveryButton: 'Restore Password',
  goBackToLogIn: 'Back to Log In',
  recoveryMessage1:
    'If we find an account with that email address, a password recovery will be sent.',
  NewPassword: 'New Password',
  SetNewPassword: 'Set New Password',
  // Info Line
  NotShared: 'Not Shared',
  // Create Account Email Register
  byCreatingYourAccount: 'By joining the site, I agree to the terms of the ',
  alsoAgree:
    'I also agree to receive messages, account updates & special offers via email',
  picturesDisclaimer:
    'Pictures are being used for illustrative purposes only and any person depicted in the Content is a model',
  step: 'Step',
  // GenderStep
  StepsTitle:
    'Join Us & Meet ' +
    (config.NICHE_SINGLES
      ? config.NICHE_SINGLES
      : config.NICHE_PLURAL.replace(/\b\w/g, (c) => c.toUpperCase())) +
    ' Lovers Now!',
  gender: 'Gender',
  startMeeting: 'Start Meeting Now',
  weNeedInfo: 'We just need a few pieces of info',
  iAm: 'I am a:',
  near: 'Near:',
  seeking: 'Seeking a:',
  next: 'Next',
  viewOtherOptions: 'View other options',
  // LocationStep
  location: 'Location',
  WhereAreYouLocated: 'Where are you located?',
  WellFindMatchesInYourArea: "We'll find matches in your area",
  EnterYourCityOrLocation: 'Enter your city or location:',
  // AgeStep
  age: 'Age',
  howOldAreYou: 'How Old Are You?',
  enterAgeBelow: 'Enter your age below',
  ageLabel: 'Age:',
  agePlaceholder: 'Your age',
  ageError: 'Age must be between < and >',
  EnterYourAge: 'Enter your age',
  // UsernameStep
  username: 'Username',
  chooseUsername: 'Choose a Username',
  itWillBeYourBio: 'It will be used on your profile bio',
  usernamePlaceholder: 'Example: ' + getCleanUsername(config.NICHE_SINGULAR),
  chooseAUsername: 'Choose a username',
  usernameError: 'This username is not valid',
  usernameLabel: 'Username:',
  usernameLabelSmall: '(6-14 Letters and Numbers)',
  enterYourNewUsername: `Enter your new username (e.g. ${getCleanUsername(
    config.NICHE_SINGULAR
  )})`,
  lettersAndNumbersOnly: 'Use letters and numbers only',
  useAtLeastOneLetter: 'Use at least one letter',
  // EmailStep
  emailPassword: 'Email/Password',
  youAreDone: "You're Almost Done...",
  createYourAccount: 'Create your account below',
  createAccount: 'Create Account',
  emailError: 'Please enter a valid email address',
  passwordError: 'Minimal password length is 6 characters',
  enterYourPassword: 'Enter your password',
  useMinChar: 'Use min. 6 characters',
  ageMissingHeadline: 'Age Request',
  EnterYourEmailAddress: 'Enter your email',
  ChooseAPassword: 'Choose a password',
  itWiilBeUsedForLogin: 'It wiil be used for login',
  // PasswordStep
  choosePassword: 'Choose Password',
  // EmailAndPasswordStep
  enterEmailAndPassword: 'Enter Your Email and Choose Password',
  // Auto-complete
  EnterYourLocation: 'Enter your location',
  EnterYourCityOrZipCode: 'Enter your City or Zip Code below:',
  enterCityOrZip: 'Enter your city or zip code',
  Menu: 'Menu',
  More: 'More',
  // Matches
  noMatchesFound: 'No Matches Found',
  wantMoreMatches: 'Want more Matches?',
  tapButtonBelow: 'Tap the button below to change your match preferences',
  editMatchPreferences: 'Edit Match Preferences',
  // MyLikes
  youHave: 'You Have',
  increaseYourMatches:
    "Increase your matches by tapping the 'Start Liking' button below",
  startLiking: 'Start Liking',
  // Mutual
  mutualLikes: 'Mutual Likes',
  // LikesMe
  membersHaveLikedYou: 'Members Have Liked You',
  // MyViews
  youHaveViewed: 'You Have Viewed',
  profiles: 'Profiles',
  membersWhoYouViewed: 'Members who you viewed will appear here',
  // ViewedMe
  memberViewedYou: 'Members Have Viewed You',
  memberWhoViewYourProfile: 'Member who view your profile will appear here',
  // Settings
  logout: 'Log Out',
  general: 'general',
  account: 'account',
  legal: 'legal',
  support: 'support',
  matchPref: 'Match Preferences',
  emailPref: 'Email Preferences',
  privacyStgs: 'Privacy Settings',
  reactivateVipMbership: 'Reactivate VIP Membership',
  youAreVipMember: 'You are a VIP Member',
  byCancelingYourVip:
    'By canceling your VIP membership, you will no longer have access to the following features once your current membership term expires',
  unLimitedMessages: 'Unlimited Messages',
  seeAllPhotos: 'See All Photos',
  unlimtedUndo: "Unlimited Undo's",
  deactivateAccount: 'Deactivate Account',
  deleteAccount: 'Delete Account',
  showMe: 'Show me',
  limitSearchToDistance: 'Limit Search To Distance',
  showAges: 'Show Ages',
  men: 'Men',
  women: 'Women',
  toastPrefUpdatedSucc: 'Preferences Updated Successfully',
  receiveEmail: 'Receive Email',
  whenSomebodySendsNewMsg: 'When somebody sends me a new message',
  whenSomebodyLikesMe: 'When somebody likes me',
  whenSomebodyVisitMyPof: 'When somebody visits my profile',
  whenNewMembersComeOnline: 'When new members come online',
  withDiscountPromotions: 'With discount promotions',
  whenSomebodyFlirtsMe: 'When somebody flirts with me',
  whenSomebodyAddsMeToFavorites: 'When somebody adds me to favorites',
  whenNearbyMembersComeOnline: 'When nearby members come online',
  withNewWaysToMeetSingles: 'With new ways to meet singles',
  whenMyFavoritesComeOnline: 'When my favorites come online',
  whenNearbyMembersUploadPhoto: 'When nearby members upload a photo',
  whenSomebodyMatchesWithMe: 'When somebody matches with me',
  whenSomebodyTriesToConnectWithMe: 'When somebody tries to connect with me',
  notifEmailPauseFor30Days: 'Pause All Email Notifications for 30 Days',
  notifEmailPausedUntil: 'Email Notifications Paused Until',
  notifOptions: 'Notification Options',
  notifUpdateSucc: 'Notifications Updated Successfully',
  privacySettingsText1: 'Control who sees your profile',
  privacySettingsText2: 'Select one or more options below',
  importantNotice: 'Important Notice',
  byDeactivatingYourAccount:
    "By deactivating your account, you won't have access to the following until you reactivate your account",
  yourMatches: 'Your matches',
  yourMessages: 'Your messages',
  yourLikes: 'Your likes',
  yourFavorites: 'Your favorites',
  allOtherInfo: 'All other information associated with your account',
  yourProfileWillBeHidden:
    'Your profile will be hidden from other members.You will not receive emails from us until you reactivate your account.Tap the button below to deactivate your account',
  areYouSure: 'Are you sure',
  yourAccountWillBeDeact: 'Your account will be deactivated',
  yesDeactivateAcc: 'Yes, Deactivate Account',
  accountSuccDeact: 'Account Successfully Deactivated',
  byDeletingYourAccount:
    'By deleting your account, the following information will be permanently deleted',
  infoUsedToCreate: 'Information used to create your account',
  yourPhotos: 'Your photos',
  yourChatHistory: 'Your chat history',
  thisActionIsNotReversible: 'This action is not reversible',
  tapTheButtonBellow: 'Tap the button below to delete your account',
  yesDeleteAccount: 'Yes, Delete Account',
  accountSuccDelete: 'Account Successfully Deleted',
  byReactivatingYourVip:
    'By reactivating your VIP Membership subscription, you will be billed at the end of the current billing period',
  tapTheButtonToReactivateVip:
    'Tap the button below to Reactivate your VIP Membership',
  yourMembershipWillExpire: 'Your membership will expire on',
  yourMembershpWillRenew: 'Your membership will renew on',
  yourVipMembershipWillReactivate: 'Your VIP membership will be reactivated',
  yesReactivateVip: 'Yes, Reactivate VIP Membership',
  noIveChangedMyMind: "No, I've Changed My Mind",
  membershipSuccessfullyReactivated: 'Membership Successfully Reactivated',
  membershipSuccessfullyCanceled: 'Membership Successfully Canceled',
  visibilityPreferences: 'Visibility Preferences',
  onlyShowMyProfileToPeopleISendMsg:
    'Only show my profile to people I send a messages to',
  dataManagement: 'Data Management',
  tapTheDownloadDataButtonBelowToViewYourAccountData:
    "Tap the 'Download Data' button below to view your account data",
  downloadData: 'Download Data',
  yesDownload: 'Yes, Download',
  yourDataWillBeDownloaded: 'Your Data Will be Downloaded',
  changePassword: 'Change Password',
  saveChanges: 'Save Changes',
  currentPassword: 'Current Password',
  confirmNewPassword: 'Confirm New Password',
  enterNewPassword: 'Enter New Password',
  passwordNotMatch: 'Password Does Not Match',
  passwordChangedSuccess: 'Password Changed Successfully',
  registredAs: 'Registred as:',
  userID: 'User-ID:',
  version: 'Version:',
  // Member
  cancel: 'Cancel',
  reportUser: 'Report User',
  blockUser: 'Block User',
  options: 'Options',
  startConversation: 'Start a Conversation',
  requestPhotoTap: 'Tap Here',
  requestPhotoTapTo: 'to Request His Photo',
  requestPhotoTapToFemale: 'to Request Her Photo',
  requestPhoto: 'to Request Photo',
  photoAlreadyRequested: 'Photo Already Requested',
  youAlreadyRequestedPhoto: "You already requested this user's photo",
  photoRequestSuccessfully: 'Photo Request Successful',
  tellWhy: 'Tell Us Why',
  inappropriatePhotos: 'Inappropriate Photos',
  inappropriateMessages: 'Inappropriate Messages',
  badOfflineBehavior: 'Bad Offline Behavior',
  feelsLikeSpam: 'Feels Like Spam',
  reportChildSafetyConcern: 'Report Child Safety Concern',
  other: 'Other',
  report: 'Report',
  reportComment: 'Report Comment...',
  blockMember: 'Block Member?',
  willNoLongerAppear: 'will no longer appear in your list of Matches.',
  yesBlock: 'Yes, Block Member',
  noCancel: 'No, Cancel',
  userReportedSuccessfully: 'User Reported Successfully',
  userBlockedSuccessfully: 'User Blocked Successfully',
  addedToFavorites: 'Added to Favorites!',
  removedFromFavorites: 'Removed from Favorites!',
  sendAMessage: 'Send a Message',
  sendUserAMessage: 'Send {user} a Message',
  wellYouveComeThisFar:
    "Well, you've come this far, might as well say something",
  chatWith: 'Chat with',
  outOfFlirts: 'Out of Flirts',
  untilYouCanSend: 'Until you can send a Flirt again.',
  wantToMakeSure: 'Want to make sure',
  seesYou: 'sees you?',
  goVipGetFlirts: 'Go VIP and get {num_of_flirts} flirts a day!',
  getMoreFlirts: 'Get More Flirts',
  noNotThisTime: 'No, not at this time',
  flirtSent: 'Flirt Sent and Liked',
  memberNotSharedAboutMe: 'This member has not shared their About Me info',
  dontWait: "Don't Wait",
  chooseFlirt: 'Choose a Flirt:',
  sendFlirt: 'Send a Flirt',
  flirtIsSent: 'Flirt is sent',
  // Chats
  chats: 'Chats',
  sentMessages: 'Sent Messages',
  yourConversations: 'Your conversations with other members will appear here',
  yourSentMessages: 'Your sent messages to other members will appear here',
  // ChatRoom
  cannotSendMessageUnlessVip:
    "You cannot send Chat messages unless you're VIp user or 'Happy Hour' is active",
  happyHour: 'Happy Hour',
  sendMessagesFree: 'Send Messages Free',
  endsIn: 'Ends in:',
  happyHourTonightAt: 'Tonight at ',
  happyHourTodayAt: 'Today at ',
  // Contact us
  ContactUs: 'Contact\u00A0Us',
  ContactUsSupport: 'Contact Us / Support',
  WhatIsYourEmail: 'What is your email address?',
  HowCanWeHelpU: 'How can we help you?',
  WriteMsg: 'Write message...',
  SendMsg: 'Send Message',
  EnterMsg: 'Enter message.',
  AlertMsgSentSuccessfully: 'Thank you! Message sent successfully.',
  ToastMsgSentSuccessfully: 'Message Sent Successfully',
  Subject: 'Subject',
  subject0: 'General Issues',
  subject1: 'VIP Membership',
  subject2: 'Fraud Report',
  subject3: 'Cancellation',
  subject4: 'Delete Account And All My Data',
  subject5: 'Other',
  // Search
  refineSearch: 'Refine Search',
  iamDoneRefining: "I'm Done Refining",
  showAdvanced: 'Show Advanced Options',
  hideAdvanced: 'Hide Advanced Options',
  cancelSearch: 'Cancel Search Refining?',
  youWillLoseYourChanges: 'You will lose all changes in your search criterias',
  yesLeavePage: 'Yes, Leave Page',
  noContinueRefining: 'No, Continue Refining',
  zeroMembersFound: 'Members Found',
  tap: 'Tap',
  // tapHere: 'Tap Here',
  // uploadAPhotoHere: 'Upload a photo here',
  toDisplayPreviousMembers: 'to display previous members.',
  toEditCurrentFilters: 'to edit your current filters.',
  resetSearch: 'Reset Search',
  tryAgain: 'Try Again',
  mile: 'Mile',
  miles: 'Miles',
  noUsers: 'No users',
  // Quick Match Button text
  undo: 'Undo',
  pass: 'Pass',
  like: 'Like',
  profile: 'Profile',
  undoNotAvailable: 'Undo Not Available',
  nothingToUndo: 'There is nothing to Undo.',
  thisIsTheFirstUser: ' This is the first user.',
  undoOnlyLastAction: 'You can only undo the last action.',
  dismissAd: 'Dismiss',
  seeMoreHere: 'See more here',
  tryChangingYourPreferences: 'Try changing your preferences.',
  errorOnInviteActionTitle: 'Error on Quick Match',
  // It's Match
  itsMutual: "It's Mutual",
  youAndMemberLikeEachOther: 'You and {member} like each other!',
  seeMoreMatches: 'See More Matches',
  // My Profile
  edit: 'Edit',
  aboutMe: 'About Me',
  youHaveNotSharedAbout: 'You have not shared your About Me info yet',
  appearance: 'Appearance',
  situation: 'Situation',
  addPhoto: 'Add Profile Photo',
  // Edit Profile
  editProfile: 'Edit Profile',
  reset: 'Reset',
  dob: 'Date of Birth',
  youWillLoseYourChangesProfile:
    'You will lose all the current changes you made in your profile',
  cancelEdit: 'Cancel editing your profile?',
  noContinueEditing: 'No, Continue Editing',
  invalidMonth: 'Invalid month',
  invalidDay: 'Invalid day',
  invalidAge: 'You must be between {min} and {max} years',
  invalidFebruar: 'February can have maximum 28 or 29 days',
  invalid30Day: 'This month can have maximum 30 days',
  invalid31Day: 'This month can have maximum 31 days',
  invalidLocation:
    'Location is invalid, please select location from dropdown list',
  locationUpdated: 'Location Successfully Updated',
  setAsMainPhoto: 'Set as Main Photo',
  changeAsMainPhoto: 'Change as Main Photo',
  deletePhoto: 'Delete Photo',
  areSureDeletePhoto: 'Are you sure you want to delete this photo?',
  noKeepPhoto: 'No, Keep Photo',
  yesDeletePhoto: 'Yes, Delete Photo',
  editPhoto: 'Edit Photo',
  profileUpdated: 'Profile Updated Successfully',
  secondaryImageAlertText:
    'This image is tagged as secondary by customer support and as such it cannot be set as profile photo.',
  reviewImageAlertText:
    'This image is not approved yet by our customer support, please try later.',
  pendingReview: 'Pending Review',
  // missing location
  locationReq: 'Location Request',
  pleaseEnterLocation: 'Please enter your location below.',
  withoutItOther: 'Without it, other members',
  cantSee: "can't see,",
  likeOrMessage: 'like, or message you.',
  submit: 'Submit',
  // missing username
  completeYourProfile: 'Complete Your Profile',
  itWillBeUsedOnYourProfileBio: 'It will be used on your profile bio',
  userNameLettersAndNumbers: '(6-14 Letters and Numbers)',
  submitUsername: 'Submit Username',
  unknownError: 'Unknown Error Occured',
  confirmUsername: 'Confirm Username',
  orChooseNewOne: 'Or choose a new one',
  // missing username and location
  welcomeToSite: 'Welcome to ' + config.TITLE,
  yourAccountIsNowActive: 'Your account is now active!',
  itsGreatToHaveYou:
    "It's great to have you here as a member of our site and look forward to helping you find that perfect\u00A0match.",
  // error
  somethingWentWrong: 'Something Went Wrong',
  networkError: 'Network Error! Please try later.',
  // invalid Token
  invalidToken: 'Your session has expired. Please Login Again',
  // rejected Username
  rejectedUsername: 'Rejected Username',
  // missing password
  missingPassword: "You're Almost Done...",
  missingPasswordText: 'Set your password below',
  missingPasswordPlaceholder: 'Minimum 6 characters',
  submitPassword: 'Set Password',
  // missing email
  missingEmail: "We're Missing Your Email",
  missingEmailText:
    'Enter your email address below for notifications when you receive new messages, likes, matches, and people who view your profile.',
  submitEmail: 'Submit Email',
  // Move and Scale
  moveAndScale: 'Move and Scale',
  crop: 'Crop',
  uploadError: 'Upload Image Error',
  whoops: 'Whoops',
  itSeemsThatIsTaking:
    "It seems that it's taking longer than usual to upload a photo. Please try again.",
  // Missing Photo
  photoRequest: 'Photo Request',
  wait: 'Wait...',
  yourMissingPhoto: "You're Missing a Photo",
  membersWithoutPhotos: 'Members without photos are 65% less',
  likelyToReceive: 'likely to receive likes and messages',
  submitPhoto: 'Submit Photo',
  takePhoto: 'Take Photo',
  chooseFromLibrary: 'Choose from Photo Library',
  // Missing Gender
  youLookingFor: 'What are you looking for',
  // Explicit Opt in Modal
  youAreAlmostDone: "You're Almost Done",
  iWouldLikeToGetSpecOffers:
    'I would like to get special offers, crazy discounts and monthly sales via email',
  iHaveReadAndAgreeToPP: 'I have read and agree to terms of',
  ByJoiningTheSiteAgreeTos: 'By joining the site, I agree to the',
  optional: 'Optional',
  required: 'Required',
  continue: 'Continue',
  // coreg
  toGetStarted: 'To Get Started',
  tapHereToGetStarted: 'Tap here to get started',
  hello: 'Hello',
  // Upgrade Modal
  membershipStatus: 'Membership Status',
  upgradeToVipChoosePlan: 'Upgrade to VIP.',
  wantUnlimitedMessages: 'Want Unlimited Messages?',
  wantToReply: 'Want to Reply to %gender%? Go VIP!',
  getUnlimitedMessages: 'Get Unlimited Messages. Choose a plan:',
  needToUndoMistake: 'Need to Undo a Mistake? Go VIP!',
  getUnlimitedUndos: "Get Unlimited Undo's - Choose a plan:",
  whoViewedYourProfile: 'Who Viewed Your Profile? Find Out!',
  peopleViewedYourProfile: 'People Viewed Your Profile',
  chooseVipPlanToSeeThem: 'Choose a VIP plan and see them:',
  wantToSeeWhoFavoritedYou: 'Want to see who Favorited You?',
  peopleFavoritedYou: 'People Favorited You',
  wantToSeeWhoLikesYou: 'Want to see who Likes You?',
  peopleLikedYou: 'People Liked You',
  youAreBasic: 'You are a Basic Member',
  wantToUnlockPhotos: 'Want to Unlock all Photos?',
  wantMoreFlirts: 'Want 5 Flirts a day?',
  vipMembershipFeatures: 'VIP Premium Membership Features Include:',
  vipMembershipFeaturesMobile: 'VIP Members Receive:',
  unlimited: 'Unlimited',
  messaging: 'Messaging',
  meetSomeoneTonight: 'Upgrade Now - Meet Someone Tonight!',
  chooseVipPlanBelow: 'Choose a VIP Plan below:',
  messagingSub: 'Keep chats going with your matches',
  viewedSub: "See who's viewed your profile",
  likesMeSub: 'Discover who liked your profile',
  unlockPhotosSub: 'See all the users photos',
  favoritedMeSub: 'See who is really interested in you',
  moreFlirtsSub: 'Increase your chances with 5 Flirts a day',
  goPrivateSub: 'Control who sees your profile',
  undoSub: 'Made a mistake? Undo your swipe!',
  select: 'Select',
  vipMembersReceive: 'VIP MEMBERS RECEIVE:',
  chooseYourPlan: 'CHOOSE YOUR PLAN:',
  enterPaymentDetails: 'ENTER YOUR PAYMENT DETAILS:',
  creditCard: 'Credit Card',
  yourSubscriptionWillRebill:
    'Your subscription will automatically rebill to a {0} membership at {1} on {2} and renew every {0} until cancelled. You may cancel at any time, via your account settings.',
  byTappingButtonBelow: 'By tapping button below, you agree to the',
  andAuthorizeToCharge:
    'and authorize us to charge your %CARD_TYPE% now and upon each renewal.',
  continueToPayPal: 'Continue to PayPal to complete your purchase.',
  proceedToPayPal: 'Proceed to PayPal',
  limitedTimeOffer: 'Limited Time Offer',
  promoHeader: '{date} VIP Membership trial for {price}',
  promoHeaderNoTrial: '{price} / {rebill_period} month(s)',
  promoSubHeaderText: 'This is an exclusive one-time offer for new members',
  promoButtonText: 'Only {price} - {date} Trial',
  promoRebillsText:
    '*Rebills every {date} for {price} if VIP membership is not cancelled before the end of the trial period*',
  accessToAllPhotos: 'Access to All Photos is available',
  toPremiumUsers: 'to Premium Users only.',
  unlimitedMessaging: 'Unlimited Messaging is available',
  upgradeTodayAndSendMessage: 'Upgrade Today To Read & Reply Messages From',
  upgradeTodayAndSeePhotos: 'Upgrade Today to Access all Photos of',
  mostPopular: 'Most Popular',
  notSuitableForCreditCard: 'Not suitable to pay by credit card?',
  weAreAccepting: 'We are accepting ',
  payPal: 'PayPal',
  // Welcome Back Modal
  weHaveAnOffer: 'We have an offer for you:',
  discount: 'discount',
  onVipMembership: 'on a VIP membership!',
  tapHereToSave: 'Tap Here to Save 50%!',
  toUnlockFeatures: 'to unlock all premium features',
  upgrade: 'Upgrade',
  upgradeNow: 'Upgrade Now',
  // Invalid Tagline
  invalidTaglineHeadline: 'Description Rejected',
  invalidTaglineTitle: "The text in your 'About Me' section wasn't approved.",
  invalidTaglineReason: 'Reason: ',
  invalidTaglineButton: 'Update Description',
  // Invalid Tagline
  photoRejectedHeadline: 'Photo Rejected',
  photoRejectedTitle: "We're sorry...",
  photoRejectedParagraph:
    'One or more of your uploaded photos was not approved.',
  photoRejectedReason: 'Reason: ',
  photoRejectedButton: 'Submit New Photo',
  viewed: 'Viewed',
  myProfile: 'My Profile',
  unlock: 'Unlock',
  allPhotos: 'All Photos',
  undos: "Undo's",
  moreFlirts: 'More Flirts',
  goPrivate: 'Go Private',
  monthFor: 'Month',
  monthsFor: 'Months',
  mo: 'mo',
  month: 'month',
  months: 'months',
  monthly: 'monthly',
  billed: 'billed',
  every: 'every',
  saveUpTo: 'Save up to',
  trialFor: 'Trial for',
  day: 'day',
  days: 'Days',
  free: 'free',
  trialRebillsAt: 'trial rebills at',
  per: 'per',
  best: 'Best',
  value: 'Value',
  // Checkout
  planSelected: 'Plan Selected',
  paymentOption: 'Payment Option',
  billingDetails: 'Billing Details',
  payByCard: 'Pay by Card',
  creditOrDebitCard: 'Pay with Credit or Debit Card',
  payWith: 'Pay with',
  pay: 'Pay',
  pal: 'Pal',
  for: 'for',
  promoRebillsAt: 'promo rebills at',
  chooseMembershipPlan: 'Choose your membership plan below',
  choosePaymentOption: 'Choose your payment option below',
  enterCardDetails: 'Enter your card details below',
  nameOnCard: 'Name on Card',
  enterFullName: 'Enter full name here',
  creditCardNumber: 'Credit Card Number',
  cardNumber: 'Card number',
  enterCardNumberHere: 'Enter card number here',
  expirationDate: 'Expiration Date',
  cvv: 'CVV/Security',
  pleaseEnterCvv: 'Please enter CVV',
  forYourPrivacyYouAreBilled: "For your privacy, you're billed discreetly as",
  byCompletingThisTransaction:
    'By completing this transaction you certify that you are at least 18 years old and that you agree to the',
  submitAndUpgrade: 'Submit and Upgrade to VIP',
  thisIsSecurePage: 'This is a secure page.',
  dataTransferIsEncrypted:
    'Data transfer is encrypted for security and protection',
  tellUsYourFullName: 'Tell us your full name as on card',
  andManyOthers: 'and many others',
  youMissedANumber: 'It seems you mistyped a number.',
  pleaseEnterYourCreditCard: 'Please enter your credit card number',
  pleaseEnterValidCreditCard: 'Please enter valid credit card number',
  pleaseEnterMonth: 'Please enter month',
  pleaseEnterValidMonth: 'Please enter valid month',
  pleaseEnterYear: 'Please enter year',
  pleaseEnterValidCvv: 'Please enter valid CVV',
  pleaseAgreeToTos: 'Please agree to the Terms of Service',
  thanksForBeingVip: 'Thanks for being a VIP member',
  subscriptionUnavailable:
    'Subscription not available because you are already VIP',
  onTheBackOfCard: 'On the back of your card you can',
  findYour: 'find your',
  cvvCvc: 'CVV/CVC',
  codeHere: 'code here.',
  hurryUp: 'Hurry up!',
  thisOfferExpires: 'This offer expires in:',
  youAreInLuck: "You're in luck!",
  thisPromoGotExtended:
    'This promo got extended. Grab it quick, as we may take this offer down any time now.',
  forYour: 'For your',
  privacy: 'privacy',
  youAreBilled: "you're billed",
  discreetly: 'discreetly',
  as: 'as',
  specialOffer: 'Special Offer',
  membershipInfo: 'Membership Info',
  // Success Upgrade
  successUpgrade: 'Upgrade Successful',
  welcomeToVip: 'Welcome to VIP!',
  youHaveSuccessfullyUpgraded: "You've successfully upgraded to a",
  vipPremiumMembership: 'VIP Premium Membership',
  importantInfo: 'Important Information!',
  pleasePrintThisPage:
    'Please print this page or write down the following information. You will need this in the future to access or change your membership information.',
  yourCreditCardBilled: 'Your credit/debit card will be discreetly billed as',
  yourPayPalCardBilled: 'Your PayPal account will be discreetly billed as',
  youWillBeDicreetlyBilled: 'You will be discreetly billed as:',
  membershipPurchased: 'Membership Purchased:',
  billingTerms: 'Billing Terms:',
  vipPremium: 'VIP Premium',
  total: 'Total',
  vip: 'VIP',
  trial: 'Trial',
  yourInfo: 'Your Information:',
  fullName: 'Full Name:',
  pleaseContactSupport:
    'Please contact support if you have any billing questions',
  billingSupport: 'Billing Support:',
  billingPhone: 'Billing Phone:',
  clickToAccessVip: 'Click to Access VIP Features',
  tapToAccessVip: 'Tap to Access VIP Features',
  thirtyDays: '30 days',
  // Process Payment
  processPayment: 'Please wait, we are processing your payment...',
  paymentProcessingError: 'Payment Processing Error!',
  // Error Component
  serviceUnavailable: 'Service temporary unavailable',
  pleaseTryLater: 'Please try later',
  // Another Client
  isOpenInAnotherWindow:
    'is open in another window. You can close this window.',
  useInThisWindow: 'Use in this window',
  // modal alert merging
  greatNews: 'Great News,',
  weAreHappy: ' We are happy to announce that, effective today, ',
  become: '{old_site} and {new_site} have become one big site: {new_site}! ',
  thisMeans:
    ' This means a bigger community for all of our members, more matches, and a greater chance to find someone special.',
  dontWorry:
    'Don’t worry, for you, as our member, nothing changes. Your login info, profile information, and history have been transferred automatically, so you’ll be able to continue where you left off. ',
  // ads
  ad: 'Ad',
  sponsored: 'SPONSORED',
  findNiche:
    'Find ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  meetNiche:
    'Meet ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  // ads random text, this is generated like this for easy transition to another niche
  adsRandomTextMeetNiche:
    'Meet ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSingleNiche:
    'Single ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextFindNiche:
    'Find ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextDateNiche:
    'Date ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheRomance:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Romance',
  adsRandomTextLonelyNiche:
    'Lonely ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheLove:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Love',
  adsRandomTextWhantNiche:
    'Want ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + '?',
  adsRandomTextNicheDates:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Dates',
  adsRandomTextMoreNiche:
    'More ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSearchNiche:
    'Search ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheNow:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Now?',
  adsRandomTextNichesingles:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Singles',
  // niche gender names
  genderTsTvTg: 'TS/TV/TG',
  genderXdresser: 'Cross\u00ADdresser',
  genderCouple: 'Couple',
  genderDom: 'Domme',
  genderFem: 'Femdom',
  genderBiCouple: 'Bi Couple',
  genderSugarMale: 'Sugar Baby Male',
  genderSugarBaby: 'Sugar Baby',
  genderHotWife: 'Hotwife/\n\u00ADCouple',
  genderMan: 'Man',
  lookingFor: 'looking for a',
  genderMilf: 'MILF',
  // onboarding
  moreInformation:
    "let's get a little more information about you so we can find other singles that match you",
  howTallAreYou: 'How Tall are you?',
  UseSliderHeight: 'Use the slider to specify your height',
  WhatIsYourEthnicity: 'What is your Ethnicity?',
  specifyYourBodyType: 'Please specify your Body Type',
  whatYouLookingFor: 'Tell us about your perfect match',
  idealMatchesAge: 'What is your ideal matches age',
  howFarAway:
    'How far away would you be willing to travel to meet your perfect match?',
  useSliderDistance: 'Use the slider to specify the distance',
  toHaveYourProfile: 'Tell other members about yourself...',
  writeSomethingAboutYourself:
    'Write something interesting about yourself, something that describes you best',
  uploadAPhoto: 'Upload a Photo',
  thisIsImportant: 'This is the most important feature of your profile!',
  youOnlyHave: 'You only have 1 chance to make a first impression.',
  tipPhoto:
    'Tip: Photos should be recent, include only you, and highlight your best qualities for best results!',
  iUploadLater: "I'll upload a photo later...",
  congratulations: 'Congratulations...',
  yourProfileUpdated:
    "Your profile has been updated and you're one step closer to finding your perfect match.",
  specialOfferNewMembers:
    "As a Special Offer for new members, we're giving you 25% off our Regular Membership Prices.",
  get25OffNow: 'Get 25% off now!',
  youWillBeRedirected: 'you will be redirected to upgrade page in',
  seconds: 'seconds',
  aNewMember: 'As a new member, you qualify for a',
  get: 'Get',
  initialOff: '25% off',
  selectedMembership: 'your selected membership',
  selectYourMembership: 'Select Your Membership Option',
  newPrice: 'New Price',
  oldPrice: 'Old Price',
  iDontWantToPayLess: "No thanks, I don't want to pay less.",
  addPhotoOnboarding: 'Add Photo',
  uploadAnotherPhoto: 'Upload Another Photo',
  finish: 'Finish',
  ifYourDoneUploadingPhotos: "If you're done uploading photos",
  // california
  CCPATitle: 'Do Not Sell My Personal Information',
  CCPAPersonal: 'My Personal Information',
  youHaveAlreadyOptedOut: 'You have already opted-out.',
  // TransactionProgress
  transactionProgress: 'Transaction Progress',
  checkingSpecialOffers: 'Checking special offers...',
  initializingTransaction: 'Initializing transaction...',
  // SpecialOffer
  congratulationsSpecialOffer: 'Congratulations!',
  youAreQualified: "You've qualified for a Special Offer!",
  toAcceptThisOffer: 'To accept this Offer, tap Continue below:',
  noThanksIDontWant: "No thanks, I don't want to pay less.",
  forYourConvenience: 'For your convenience, you will be rebilled',
  on: 'on',
  andEvery: 'and every',
  daysThereafter: 'days thereafter, unless canceled.',
  off: 'off',
  yourSelectedMembership: 'your selected membership.',
  // Transaction Declined
  transactionDeclined: 'Transaction Declined',
  yourCreditCardWasNotApproved:
    'Your credit card was not approved for our special membership offer.',
  butWait: "but WAIT... here's one more special offer",
  tryA: 'Try a',
  forOnly: 'for only',
  acceptOffer: 'Accept Offer',
  membership: 'Membership',
  // Measure System
  measureSystem: 'Measure System',
  imperial: 'Imperial',
  metric: 'Metric',
  // kink cam banner
  viewNow: 'View Now',
  youGotAFree: 'You Got a Free',
  // receipt page
  bonusMembership: 'Bonus Membership',
  membersLoginArea: 'Members Login Area',
  // language
  language: 'Language',
  // OneClick
  signInFromReferal: 'Sign In With Your Profile from Referring Site',
  siteWouldLikeToAccess:
    config.TITLE +
    ' would like access to the following information to register you on this site:',
  permissionsToAccess:
    'Name, Email, Date of Birth, Location and Basic Dating Profile Details',
  iConsentToDetailsAndRegister:
    'I consent to these details being used to register my profile and confirm I agree to ',
  allow: 'Allow',
  byClickingAllow:
    'By clicking ALLOW you consent to these details being used by ' +
    config.TITLE +
    ' to register you to the dating site and confirm that agree to the Terms and Conditions linked below. Alternatively you can use our ',
  standardRegistrationForm: 'standard registration form',
  // SpecialOffer2x
  getFreeMembership: 'Get a FREE Membership at {0}',
  doubleYourChances: 'Double Your Chances To Meet Someone',
  weHavePartnered:
    "We've partnered up with {0}, to help increase our members chances at finding a match. Once you click the button above, we will automatically create a 100% FREE PROFILE at {0}, and redirect you to the members area, so you can start searching their database for potential matches.",
  congratulationsYouGotFree:
    'Congratulations, you got FREE membership at {site_name}.',
  toGetLoggedInto: ' to get logged into the site.',
  // RefundCreditCard
  refundCreditCard: 'Refund With New Credit Card',
  refundCreditCardSuccess:
    'Your request for refund has been successfully submitted.',
  // NearbyConnect
  nearbyConnect: 'Nearby Connect',
  nearbyDecline: 'No thanks, I do not want to send it now, I will do it later.',
  introduceMyself: 'Introduce Myself',
  distance: 'Distance',
  anyDistance: 'Any Distance',
  message: 'Message',
  sentByNearbyConnect: 'Sent By NearbyConnect',
  typeYourMessageHere: 'Type your message here',
  sendThisToMyNewMatches: 'Also send this to all new matches as they join',
  successNearbyConnect: 'You successfully setup Nearby Connect',
  nearbyConnectTitle:
    'Get in touch with hundreds of members right away! Only users who match your profile will receive these messages. Enter your message below to get started:',
  nearbyConnectAlert:
    'Nearby Connect messages are unique messages from other real members who could be your perfect match. These messages are automatically sent only to users that match that user profile.',
  nearbyUnavailable:
    'Sorry, the NearbyConnect feature is not available at the moment. This feature can be used once per 30 days. Thank you for your understanding.',
  nearbyFeatureUsed: 'You used the NearbyConnect feature on {date}.',
  toKeepNearbyFree:
    'To keep the NearbyConnect Free, we limit it to only one introduction every 30 day(s).',
  ifYouLikeToBeIntroduced:
    "If you'd like to be introduced to more members, come back on {date}.",
  nearbyConnectValentineTitle: 'Valentine Special',
  nearbyConnectValentineText1:
    "Valentine's Day is getting close. For a limited time, we'll let you send a ",
  nearbyConnectValentineText2: 'FREE introduction message ',
  nearbyConnectValentineText3:
    'to hundreds of users who match your preferences. Just enter your message below to get started:',
  // subscription status
  subscriptionStatus: 'Subscription Status',
  subscritpionStatusManageLink1:
    'Congratulations! You are a VIP Member. Please visit ',
  subscritpionStatusManageLink2: ' to manage your subscription.',
  subscriptionUpgradeLink1: 'You are a basic member. ',
  subscriptionUpgradeLink2: ' Upgrade to VIP now!',
  // Manage Nearby Connects
  manageNearbyConnects: 'Manage Nearby Connect',
  sendNewNearbyConnectMessage: 'Send New NearbyConnect Message',
  activeUntil: 'Active Until',
  sendToNewJoins: 'Send To New Joins',
  update: 'Update',
  disable: 'Disable',
  nearbyConnectUpdated: 'Nearby Connect Updated Successfully',
  nearbyConnectWillBeAvailable:
    'Nearby Connect will be available to you next time on ',
  canChangeMessageOn: 'Can change message on',
  getInTouchWith:
    'Get in touch with hundreds of members right away! Only users who match your profile will receive these messages.',
  // Cookie Consent
  cookieConsentText:
    'The site uses cookies. By continuing to navigate the site you explicitly agree to using the cookies.',
  cookieConsentDetailsLinkText: 'Details',
  cookieConsentButtonText: 'I understand',
  cookieConsentDeclineButtonText: 'close',

  cookieTitle: 'This site uses cookies',
  cookieSubTitle:
    'We use cookies and other tracking technologies to improve your browsing experience on our website, to show you personalized content and targeted ads, to analyze our website traffic, and to understand where our visitors are coming from.',
  cookieAcceptAllCookies: 'Accept All',
  cookieDeclineAllCookies: 'Decline All',
  cookieManagePreferences: 'Change my Preferences',
  cookieClosePreferences: 'Close Preferences',
  cookieNecessaryTitle: 'Necessary',
  cookieNecessaryDescription:
    'These cookies are essential to provide you with services available through our website and to enable you to use certain features of our website. Without these cookies, we cannot provide you certain services on our website.',
  cookieActiveText: 'Active',
  cookieAlwaysActiveText: 'Always Active',
  cookieInactiveText: 'Inactive',
  cookieFunctionallityTitle: 'Functionallity',
  cookieFunctionallityDescription:
    'These cookies are used to provide you with a more personalized experience on our website and to remember choices you make when you use our website. For example, we may use functionality cookies to remember your language preferences or remember your login details.',
  cookieAnalyticsTitle: 'Analytics',
  cookieAnalyticsDescription:
    'These cookies are used to collect information to analyze the traffic to our website and how visitors are using our website. For example, these cookies may track things such as how long you spend on the website or the pages you visit which helps us to understand how we can improve our website for you. The information collected through these tracking and performance cookies do not identify any individual visitor.',
  cookieMarketingTitle: 'Marketing',
  cookieMarketingDescription:
    "These cookies are used to show advertising that is likely to be of interest to you based on your browsing habits. These cookies, as served by our content and/or advertising providers, may combine information they collected from our website with other information they have independently collected relating to your web browser's activities across their network of websites. If you choose to remove or disable these targeting or advertising cookies, you will still see adverts but they may not be relevant to you.",
  cookieOtherTitle: 'Other',
  cookieOtherDescription: 'Some other cookies',
  cookieSavePreferences: 'Save Preferences And Close',
  cookiePreferencesTitle: 'Choose your Preferences',
  manageCookies: 'Manage Cookies',
  cookiesViewDetails: 'View Details',
  cookiesProviders: 'Cookies Providers',
  cookiesYahoo: 'Used by Yahoo for content and advertising personalisation.',
  cookiesGoogleDetectSpam: 'Used to detect spam, fraud, and abuse.',
  cookiesGoogleAds:
    'Used to personalize Google ads based on recent searches and interactions.',
  years: 'years',
  year: 'year',
  cookiesGoogleAdDelivery: 'Used to provide ad delivery or retargeting.',
  cookiesGoogleUseOurSite:
    'Cookie used to collect information about how visitors use our Site.',
  cookiesGoogleDistinguishUsers: 'Used to distinguish users.',
  cookiesGoogleCrossSite:
    'This cookie is used to prevent the browser from sending this cookie along with cross-site requests.',
  cookiesGoogleUniqueIdTracking:
    'These cookies use an unique identifier for tracking purposes',
  cookiesGoogleProtectData:
    "Security cookie to protect a user's data from unauthorized access.",
  cookiesGoogleTrackConversions: 'Used to store and track conversions.',
  cookiesBingAds:
    'This cookie allows to serve relevant advertisements to visitors.',
  cookiesBingTracking:
    'Microsoft User Identifier tracking cookie used by Bing Ads.',
  cookiesBingClarityID:
    'Persists the Clarity User ID and preferences, unique to that site is attributed to the same user ID.',
  cookiesBingClarityMultiple:
    'Connects multiple page views by a user into a single Clarity session recording.',
  cookiesBingTrackingAdvertising:
    'This is a tracking cookie used by Microsoft Bing advertising to allow us to engage with a visitor that has previously visited our website.',
  cookiesFacebookTracking: 'Used to store and track visits across websites.',
  cookiesFacebookUniqueId:
    'Used to store unique identifier for your browser that, amongst other things, helps us protect you from fraud.',
  cookiesFacebookDevicePixelRatio:
    "Used to record the device pixel ratio of your screen and whether or not you've enabled high-contrast mode, so that we can render our sites optimally.",
  cookiesFacebookMarketing: 'Used to provide ad delivery or retargeting.',
  cookiesGoogleDoubleClick:
    "Used by Google DoubleClick to register and report the website user's actions after viewing or clicking one of the advertiser's ads with the purpose of measuring the efficacy of an ad and to present targeted ads to the user.",
  cookiesBingRefreshMuid: 'Indicates whether to refresh MUID.',
  cookiesRomanceGuard: 'Used for detection of fraud, spam, malware.',
  cookiesTaboolaUniqueId:
    'Assigns a unique, partitioned User ID that Taboola uses for attribution and reporting purposes, and to tailor recommendations to this specific user based on interactions with one advertiser or publisher.',
  cookiesSnapchatId: 'Used to help identify a visitor.',
  cookiesSnapchatTrackId:
    'Sets a unique ID for the visitor, that allows third party advertisers to target the visitor with relevant advertisement. This pairing service is provided by third party advertisement hubs, which facilitates real-time bidding for advertisers.',
  cookiesSnapchatPixelId:
    'Used to determine whether a third party tag will be called in a Snap Ads Pixel.',
  cookiesVWOVisits: 'Used to store unique visits.',
  cookiesVWOTest: 'Used to read if cookies can be placed.',
  cookiesVWOSafari:
    'This cookie is a jar of all the cookies. It is currently created only for the Safari browser. In the future, it will replace all VWO cookies. NOTE: The actual expiry of this cookie is irrelevant as it stores the expiry of cookies set in it and keeps on expiring them.',
  cookiesVWODS:
    'This cookie stores persistent visitor-level data for VWO Insights.',
  cookiesVWOExpiration: 'Depends on the retention period of the account.',
  cookiesVWOUniqueId:
    'This cookie generates a unique ID for every visitor and is used for the report segmentation feature in VWO. It also allows to view data in a more refined manner.',
  cookiesVWOUniqueVisits:
    'This cookie calculates unique visitors traffic on a website.',
  cookiesAppsFlyer:
    'We use this service to detect users devices such as iOS iPhone or Android Phone to display banner to users to let them know if they want to install native application from iStore or Google Play Store.',
  cookiesTikTok:
    "To measure and improve the performance of your advertising campaigns and to personalize the user's experience (including ads) on TikTok.",
  cookiesRaygun:
    'Raygun provides error, crash and performance monitoring for software teams.',
  name: 'Name',
  description: 'Description',
  duration: 'Duration',
  url: 'URL',
  domain: 'Domain',

  // email verification
  welcome: 'Welcome',
  emailConfirmationTitle: 'Confirm Your Email to Stay Connected!',
  emailConfirmationDesc:
    'Your email isn’t confirmed yet, so you’re currently not receiving any emails or messages!',
  weRecomend:
    'We recommend you click on the button to resend the link, then check your email.',
  resendConfirmation: 'RESEND CONFIRMATION EMAIL LINK',
  ifForAnyReason: 'If for any reason you wish to change your email address, ',
  dontSeeIt: "Don't see it?",
  andWeWillResend:
    'and we will resend the email immediately so it will be easy to locate!',
  checkSpamFolder: 'Check the Spam Folder',
  ifYouDoNotSeeYourMessage:
    'If you do not see your message in the Inbox, check the spam folder.',
  thenSelect: 'Then, select the message and mark it as NOT SPAM.',
  needHelp: 'Need help? ',
  ClickHereForMoreInfo: 'Click here for more info',
  addUsToYouContacts: 'Add us to your Contact List',
  beSureToAdd: 'Be sure to add',
  notifyEmail: 'notify@nearbynotifications.com',
  toYourAddressBook:
    'to your address book/contact list so your messages and flirts get to your inbox.',
  copiedToClipboard: 'Copied To Clipboard',
  cantWait:
    "Can't wait to help you find your perfect match. We have 1000's of members waiting to meet you...",
  seeYou: 'See you on the inside!',
  emailConfirmationDecline:
    'No thanks I do not want to send it now, I will do it later.',
  emailConfirmationToast:
    'Email Confirmation Link Sent Successfully. Please check your email.',

  // addUsToContactsInfo
  addUsToYouContactsList:
    'Add ' +
    config.DOMAIN.replace(/https?:\/\//, '').toUpperCase() +
    ' to your Contacts list to avoid ',
  missingAnyMessage: 'MISSING any messages!',
  contactsInfoDetails:
    'Add ' +
    config.DOMAIN.replace(/https?:\/\//, '').toUpperCase() +
    ' to your address book or contact list so you do not miss any messages or flirts.',
  openMessageStep:
    'Open a message from the sender you want to save as a contact in Gmail.',
  hoverCursorStep:
    "Hover your cursor over the sender's name at the top of the email.",
  selectAddToContactsStep: 'Select Add to Contacts on the pop-up menu.',
  resendConfirmationLinkText: 'Click Here to Resend your confirmation Link',
  toMakeItEasier: 'so it will be easier to locate in your mailbox!',
  checkGmailInbox: 'CHECK YOUR GMAIL INBOX',

  // checkSpamFolder
  beSure: 'Be sure to check the',
  spamFolder: 'Spam folder',
  ifYouDoNotSeeMessage: "if you don't see our message in the inbox!",
  spamFolderDetails:
    'If you find our message was wrongly classified as spam, you can unmark the message.',
  unmarkingAMessage:
    'Unmarking a message will automatically move it to your inbox.',
  openSpamFolderStep: 'Click Spam along the left side of any page.',
  selectMessageStep: 'Select the message.',
  markAsNotSpamStep: "Click 'Not spam' at the top of the page.",

  // change email
  changeEmail: 'Change Email!',
  newEmailAddress: 'New Email Address',
  currentEmailAddress: 'Current Email Address',

  // cancel web subscription
  cancelVipMembership: 'Cancel VIP Membership',
  yesCancelVip: 'Yes, Cancel VIP Membership',
  noKeepVip: 'No, Keep VIP Membership',
  doYouWantToGiveUpVip: 'Do you want to give up all these fantastic features',
  cancelSubscriptionSuccess: 'Subscription Successfully canceled.',
  resubscribeVip: 'Resubscribe to VIP',
  weWillNotRenewYourSubscription:
    'Your subscription is currently active, however, you have canceled it. Once your subscription expires, it will not be renewed, and you will lose access to premium features. You can resubscribe anytime before expiration to continue enjoying your benefits.',
};



// WEBPACK FOOTER //
// ./src/assets/localization/en.js